import React from "react";
import { Doughnut } from "react-chartjs-2";

const options = {
  maintainAspectRatio: true,
  cutout: "86%", // Controls the thickness of the donut (e.g., "70%" or a pixel value)
  // rotation: 0, // Start angle in degrees (default 0)
  // circumference: 360, // Sweep angle in degrees (default 360)
  plugins: {
    legend: {
      display: false,
      position: "top", // "top", "bottom", "left", "right"
      labels: {
        color: "#333",
        font: {
          size: 14,
          weight: "bold",
        },
        padding: 20,
        boxWidth: 20,
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          return `${context.label}`;
        },
        afterLabel: (context) => `${context.parsed}%`,
      },
      enabled: true,
      backgroundColor: "#fff",
      titleColor: "black",
      bodyColor: "black",
      borderColor: "slategrey",
      borderWidth: 1,
      padding: 10,
      cornerRadius: 8,
      displayColors: false, // <-- Add this line to hide color box in tooltip
      // ...other tooltip options...
    },
    // datalabels: { ... } // If using chartjs-plugin-datalabels
  },
  layout: {
    padding: 40, // Padding around the chart
  },

  animation: {
    animateRotate: true,
    animateScale: true,
  },
  scales: {
    y: {
      title: {
        display: false,
      },
      ticks: {
        display: false,
      },
      grid: {
        display: false, // Hide y-axis gridlines
        drawBorder: false,
      },
    },
    x: {
      suggestedMax: 100,
      title: {
        display: false,
      },
      ticks: {
        display: false,
      },
      grid: {
        display: false, // Hide x-axis gridlines
        drawBorder: false,
      },
    },
  },
};

const PercentageChart = ({ activeFilter, statsForActiveFilter }) => {
  const chartData = {
    labels: statsForActiveFilter.map((c) => c.name),
    datasets: [
      {
        data: statsForActiveFilter.map((c) => c.percentageOfTotalValue),
        borderRadius: 2,
        borderWidth: 1,
        barPercentage: 0.9,
        backgroundColor: statsForActiveFilter.map((v) => v.color),
        borderColor: "#000",
        spacing: 3,
        offset: 2,
        hoverOffset: 10, // <-- This makes the hovered section "pop out"
      },
    ],
  };

  return (
    <div
      style={{
        minWidth: 260,
        flexBasis: 260,
        marginLeft: 16,
        flexShrink: 0,
        height: 260,
        width: 260,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: 20,
        background: "#eeeeee80",
        borderRadius: 12,
        flexDirection: "column",
      }}
    >
      <span
        style={{
          fontWeight: 600,
          fontSize: 14,
          textAlign: "center",
          maxWidth: 200,
        }}
      >
        {activeFilter}
      </span>
      <span style={{ fontWeight: 400, color: "slategrey", fontSize: 11 }}>
        Percentage Breakdown
      </span>
      <div
        style={{
          height: 190,
          width: 236,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Doughnut options={options} data={chartData} />
      </div>
    </div>
  );
};

export default PercentageChart;
